import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "remixicon/fonts/remixicon.css";
import { initializeGoogleMapsBootstrap } from "./lib/google-maps-loader";

// Initialize Google Maps bootstrap loader early
initializeGoogleMapsBootstrap();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
